module.exports = __webpack_public_path__ + "static/media/flexible-image-3.bbdecc8f.jpg";